import { useMemo } from 'react';
import { AsyncComponentHookResult } from '../../../../../../Types/ComponentHookResult';
import { useGoal } from '../../../../hooks/useGoal';

interface CharitableGivingAssumptionsDTO {
  PropertyType: string;
  DonationAmount: string | number;
  EarmarkedAccounts: number;
  DonationYear: string;
  GrantYear: string | null;
  DonationStartYear: number | null;
  DonationEndYear: number | null;
  GivingStrategy: string;
  GrantAmount: string;
}

export const useAssumptions = (
  goalId?: string,
): AsyncComponentHookResult<CharitableGivingAssumptionsDTO> => {
  const queryResult = useGoal({ goalId });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    return queryResult.data.GoalAssumptions as CharitableGivingAssumptionsDTO;
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
